import PropTypes from 'prop-types';
import React from 'react';

export default class BaseIcon extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    size: PropTypes.string,
    viewBox: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    viewBox: '0 0 60 60',
  };

  getViewBox() {
    let viewBox = this.props.viewBox;

    if (this.props.size && this.props.size === 'mini') {
      viewBox = '0 0 8 8';
    }

    return viewBox;
  }
}



// WEBPACK FOOTER //
// ./client/src/javascript/components/icons/BaseIcon.js